import router from '@/router'

const entry = {
  router,
  mounted() {
    window.appAudio = document.querySelector('#appAudio')

    // TODO: 待解决 DOMException
    // const src = window.appAudio.getAttribute('src')
    // if (!src) { // 这里不能用 window.appAudio.src 进行判断
    //   return
    // }
    try {
      document.addEventListener('DOMContentLoaded', () => {
        document.addEventListener('WeixinJSBridgeReady', this.playAudio, false)
        this.playAudio()
      }, false)
    } catch (error) {
      //
    }
    
    
  },
  render() {
    return <router-view />
  },
  methods: {
    playAudio() {
      try {
        window.appAudio.load()
        window.appAudio.play()
      } catch (err) {
        // do nothing
      }
    }
  }
}

const app = {
  el: document.getElementById('app'),
  name: 'app',
  components: { entry },
  mounted(){
    if(+this.getQueryString('is_case') === 1){
      $("body").append('<div id="toProgram" style="width: 100%;height: 3.07rem;display: flex;align-items: center;justify-content: center;background-color: #fff;border-radius: 1.2rem 1.2rem 0 0;position: fixed;z-index: 9999;bottom: 0;box-shadow: 0.3rem -0.2rem 0.6rem 0 rgba(124,124,124,0.1);"><div style="background-color: #FF0618;color: #fff;width: 90%;height: 2.11rem;font-size: 0.77rem;display: flex;justify-content: center;align-items: center;border-radius: 12rem;">登录电脑端后台创建</div></div>')
      // $("body").append('<div id="toProgram" style="position: fixed;width: 100%;background: #1b76ff;color: #fff;text-align: center;padding: 0.3rem;bottom: 0;z-index: 99999;font-size: 14px;">我也要创建</div>')
      $("body").attr('style', $("body").attr('style')+"padding-bottom:1.7rem;")
      let ua = navigator.userAgent.toLowerCase()

      if (ua.match(/MicroMessenger/i)[0] === 'micromessenger') { //微信环境
        $("#toProgram").on('click',function() {
          // 点击跳转小程序页面
          wx.miniProgram.redirectTo({
            url: '/pages/home/create-activity/index',
          })
        })
      }
    }
  },
  methods:{
    getQueryString(name) {
      let reg = `(^|&)${name}=([^&]*)(&|$)`
      let r = window.location.search.substr(1).match(reg)
      if (r !== null) return unescape(r[2]); return null
    },
  },
  render() {
    return <entry />
  }
}

export default app